import { useState, useEffect } from 'react';

export function usePersistedState<T>(
  key: string,
  defaultValue: T,
  storage: Storage = sessionStorage
): [T, React.Dispatch<React.SetStateAction<T>>] {
  // Get the initial value from storage or use the default
  const [state, setState] = useState<T>(() => {
    try {
      const item = storage.getItem(key);
      return item ? JSON.parse(item) : defaultValue;
    } catch (error) {
      // Silently handle storage load error
      return defaultValue;
    }
  });

  // Update storage when state changes
  useEffect(() => {
    try {
      storage.setItem(key, JSON.stringify(state));
    } catch (error) {
      // Silently handle storage save error
    }
  }, [key, state, storage]);

  return [state, setState];
}